import querystring from 'query-string'

// 1. Add 'location' as an optional parameter, falling back safely for SSR
export const getPkgRguid = (
  location = globalThis.window !== undefined ? globalThis.window.location : null
) => {
  // 2. Safe early return if location is null (SSR) or has no search string
  if (!location?.search) return
  const queryStringParameters = querystring.parse(location.search)
  return queryStringParameters?.['pkg-rguid']
}
